// internationalization
import { useTranslation } from 'react-i18next';

// material ui icons
import RouterRoundedIcon from '@mui/icons-material/RouterRounded';

// material ui
import { Stack, Typography } from '@mui/material';

// feature-components
import CopyableIdField from '@/features/devices/components/shared/CopyableIdField';
import DetailHeaderCard from '@/features/devices/components/shared/DetailHeaderCard';
import DetailInfoField from '@/features/devices/components/shared/DetailInfoField';
import useCopyToClipboard from '@/features/devices/components/shared/hooks/useCopyToClipboard';

// relative
import GatewayStatusCell from './GatewayStatusCell';

const GatewayDetailHeader = ({ gateway }) => {
  const { t } = useTranslation('units-gateways-sensors');
  const copyToClipboard = useCopyToClipboard();

  const handleCopyGatewayId = () =>
    copyToClipboard(
      gateway?.GatewayId,
      t('gateways.gatewayIdCopied', { id: gateway.GatewayId }),
      t('gateways.gatewayIdCopyFailed'),
    );

  return (
    <DetailHeaderCard
      title={gateway?.Name || t('common.notAvailable')}
      subheader={gateway?.Description}
      avatar={<RouterRoundedIcon fontSize="medium" />}
    >
      <DetailInfoField label={t('gateways.status')}>
        <Stack direction="row" sx={{ ml: -1 }} alignItems="center" spacing={1}>
          <GatewayStatusCell gateway={gateway} />
        </Stack>
      </DetailInfoField>

      <DetailInfoField label={t('gateways.gatewayId')}>
        <CopyableIdField
          value={gateway?.GatewayId}
          notAvailableText={t('common.notAvailable')}
          onCopy={handleCopyGatewayId}
        />
      </DetailInfoField>

      <DetailInfoField label={t('gateways.reportedFirmware')}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            {gateway?.CurrentApplicationFirmware || t('common.notAvailable')}
          </Typography>
        </Stack>
      </DetailInfoField>
    </DetailHeaderCard>
  );
};

export default GatewayDetailHeader;
